import React, { Component } from 'react';

import Button from '@mui/material/Button';
import classnames from 'classnames';
import { WithStyles, withStyles } from '@mui/styles';

import APSegmentedControlOptionStyles from './styles/APSegmentedControlOption.style';

interface APSegmentedControlOptionProps extends WithStyles<typeof APSegmentedControlOptionStyles> {
  disabled?: boolean,
  onClick: any,
  selected: boolean,
  value: any,
  children?:any
}

class APSegmentedControlOption extends Component<APSegmentedControlOptionProps, {}> {
  constructor(props: APSegmentedControlOptionProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const {
      onClick,
      value
    } = this.props;

    if (onClick) {
      onClick(value);
    }
  }
  render() {
    const {
      children,
      classes,
      disabled = false,
      selected
    } = this.props;

    const buttonCls = classnames(classes.button, {
      [classes.selected]: selected
    });

    return (
      <Button className={buttonCls} disabled={disabled} onClick={this.onClick} data-testid='segmentControl-button'>
        {children}
      </Button>
    );
  }
}

export default withStyles(APSegmentedControlOptionStyles)(
  APSegmentedControlOption
);
